// src/components/menus/SettingsPageSubMenu.tsx
import React from 'react';
import { BeingsPageSubMenuButton } from '../common/Buttons';
import { SubMenuContainer, SubMenuCap } from './shared/MenuElements';

interface SettingsPageSubMenuProps {
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
  bottomBorder?: boolean;
  buttonBottomBorder?: boolean;
  showUsersTab?: boolean;
  showRecycleBinTab?: boolean;
}

// Exported so SettingsPage can reuse these ids as the single source of
// truth when persisting the selected tab to the URL, rather than keeping a
// second list of ids in sync by hand.
export const allTabItems = [
  { id: 'system', label: 'SYSTEM', minWidth: '154px', index: 0 },
  { id: 'prices', label: 'PRICES', minWidth: '140px', index: 1 },
  { id: 'pets', label: 'PETS', minWidth: '112px', index: 2 },
  { id: 'kennels', label: 'KENNELS', minWidth: '170px', index: 3 },
  { id: 'vets', label: 'VETS', minWidth: '112px', index: 4 },
  { id: 'users', label: 'USERS', minWidth: '131px', index: 5 },
  { id: 'recycle-bin', label: 'RECYCLE BIN', minWidth: '224px', index: 6 },
];

const SettingsPageSubMenu: React.FC<SettingsPageSubMenuProps> = ({
  selectedTab,
  setSelectedTab,
  bottomBorder = true,
  buttonBottomBorder = false,
  showUsersTab = true,
  showRecycleBinTab = true,
}) => {
  const visibleTabs = allTabItems.filter(
    (item) =>
      (item.id !== 'users' || showUsersTab) &&
      (item.id !== 'recycle-bin' || showRecycleBinTab)
  );

  return (
    <SubMenuContainer bottomBorder={bottomBorder}>
      {visibleTabs.map((item) => (
        <BeingsPageSubMenuButton
          key={item.id}
          onClick={() => setSelectedTab(item.index)}
          isActive={selectedTab === item.index}
          minWidth={item.minWidth}
          showBottomBorder={buttonBottomBorder}
        >
          {item.label}
        </BeingsPageSubMenuButton>
      ))}
      <SubMenuCap />
    </SubMenuContainer>
  );
};

export default SettingsPageSubMenu;
